module.exports = __webpack_public_path__ + "img/search.e0604d42.svg";